const EPISODIC_CITATION = "40 CFR 262 subpart L";

export type RuleSource = { label: string; color: "default" | "info" | "secondary" };

/** Which body of law a clock limit comes from, for the source badge. */
export function deriveRuleSource(limit: { citation: string; jurisdiction: string }): RuleSource {
  if (limit.citation === EPISODIC_CITATION) {
    return { label: "Episodic", color: "secondary" };
  }
  if (limit.jurisdiction === "FEDERAL") {
    return { label: "Federal", color: "default" };
  }
  return { label: limit.jurisdiction, color: "info" };
}
